import { useFeatureFlag } from '@/store/slices/api/featureFlagsApiSlice';
import { routes } from '@/routes';

export const usePatientListFeatureFlag = () => {
  const isNewPatientListPageEnabled = useFeatureFlag('new-patient-list-page-v2');

  const getDefaultPatientListRoute = () => {
    return isNewPatientListPageEnabled ? routes.physician.patientsList : routes.physician.patients;
  };

  return {
    isNewPatientListPageEnabled,
    getDefaultPatientListRoute: getDefaultPatientListRoute
  };
};
